import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from './base-query';

const creditAPI = createApi({
    reducerPath: "creditAPI",
    baseQuery,
    endpoints: (builder) => ({
        getAllCreditAppliedCustomers: builder.mutation({
            query: ({ page, size, key }) => {
                let apiUrl = `admin/customer-credit?page=${page}&limit=${size}`;

                if (key) {
                    apiUrl += `&search=${key}`;
                }

                return {
                    url: apiUrl,
                    method: "GET",
                };
            },
            transformResponse: (response) => response,
            providesTags: ["credit_applied_customers"],
        }),
        getGlobalCreditDetails: builder.mutation({
            query: () => {
                let apiUrl = `admin/global-credit`;

                return {
                    url: apiUrl,
                    method: "GET",
                };
            },
            transformResponse: (response) => response,
            providesTags: ["global_credit"],
        }),
        updateGlobalCredit: builder.mutation({
            query: ({ data }) => {
                return {
                    url: `admin/global-credit`,
                    method: "PUT",
                    body: data
                };
            },
            invalidatesTags: ["global_credit"],
        }),
        updateAllCustomerCredits: builder.mutation({
            query: () => {
                return {
                    url: `admin/customer-credit/all-customer`,
                    method: "PUT"
                };
            },
            invalidatesTags: ["credit_applied_customers"],
        }),
        updateSpecificCustomerCredits: builder.mutation({
            query: ({data}) => {
                return {
                    url: `admin/customer-credit`,
                    method: "PUT",
                    body: data
                };
            },
            invalidatesTags: ["credit_applied_customers"]
        }),


        applyCreditApplication: builder.mutation({
            query: ({ data }) => {
                return {
                    url: "admin/credit-application",
                    method: "POST",
                    body: data
                };
            },
            invalidatesTags: ["customers"]
        }),
        editCreditApplication: builder.mutation({
            query: ({ data }) => {
                return {
                    url: "admin/credit-application",
                    method: "PUT",
                    body: data
                };
            },
            invalidatesTags: ["customers"]
        }),
        getAllCreditApplications: builder.mutation({
            query: ({ page, size, key }) => {
                let apiUrl = `admin/credit-application?page=${page}&limit=${size}`;

                if (key) {
                    apiUrl += `&search=${key}`;
                }

                return {
                    url: apiUrl,
                    method: "GET",
                };
            },
            transformResponse: (response) => response,
            providesTags: ["credit_applications"],
        }),
        getSpecificCreditApplication: builder.mutation({
            query: ({ id }) => {
                let apiUrl = `admin/credit-application/${id}`;

                return {
                    url: apiUrl,
                    method: "GET",
                };
            },
            transformResponse: (response) => response
        }),
        approveCreditApplication: builder.mutation({
            query: ({ data }) => {
                return {
                    url: "admin/credit-application/approve",
                    method: "POST",
                    body: data
                };
            },
            invalidatesTags: ["credit_applications"],
        }),
        rejectCreditApplication: builder.mutation({
            query: ({ data }) => {
                return {
                    url: "admin/credit-application/reject",
                    method: "POST",
                    body: data
                };
            },
            invalidatesTags: ["credit_applications"],
        })
    })
});

export const { 
    useGetAllCreditAppliedCustomersMutation,
    useGetGlobalCreditDetailsMutation,
    useUpdateGlobalCreditMutation,
    useUpdateAllCustomerCreditsMutation,
    useUpdateSpecificCustomerCreditsMutation,

    useApplyCreditApplicationMutation,
    useEditCreditApplicationMutation,
    useGetAllCreditApplicationsMutation,
    useGetSpecificCreditApplicationMutation,
    useApproveCreditApplicationMutation,
    useRejectCreditApplicationMutation
} = creditAPI;

export default creditAPI;